/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_PublicInputs */



/**
* | output |
* | --- |
* | "Public" |
*
* @param {Og_Cfg_PublicInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_public = /** @type {((inputs?: Og_Cfg_PublicInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_PublicInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Public")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pública")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pública")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblica")
	return /** @type {LocalizedString} */ ("Public")
});